import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Polygon, Marker } from '@react-google-maps/api';
import {
    relocateZoneDraftCoords,
    zoneDraftMapControlSelector, zoneDraftCoordsSelector, zoneDraftColorSelector
} from '../../../features/places/placesSlice';

const options = {
    fillColor: "lightblue",
    fillOpacity: 0.3,
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1
}

const ZoneCreate = () => {

    const dispatch = useDispatch();
    const zoneDraftMapControl = useSelector(zoneDraftMapControlSelector);
    const zoneDraftCoords = useSelector(zoneDraftCoordsSelector);
    const zoneDraftColor = useSelector(zoneDraftColorSelector);


    const relocateVertex = (e, i) => {
        dispatch(relocateZoneDraftCoords({
            index: i,
            coords: {
                lat: e.latLng.lat(),
                lng: e.latLng.lng()
            }
        }))
    }

    if (!zoneDraftMapControl) {
        return null;
    } else {
        return (
            <div>
                <Polygon
                    paths={zoneDraftCoords}
                    options={{
                        ...options,
                        fillColor: zoneDraftColor,
                        strokeColor: zoneDraftColor,
                    }}
                />
                {
                    zoneDraftCoords.map((v, i) =>
                        <Marker
                            position={v}
                            label={`${i + 1}`}
                            onClick={() => { }}
                            draggable={true}
                            onDragEnd={(e) => relocateVertex(e, i)}
                            key={i}
                        />
                    )
                }
            </div>
        );
    }


}

export default ZoneCreate;